











  import { ValidationProvider } from 'vee-validate';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'ValidationFormulaire',
    components: {
      ValidationProvider,
    },
    props: {
      validation: {
        type: String,
        default: '',
      },
      nom: {
        type: String,
        required: true,
      },
      immediate: {
        type: Boolean,
        default: false,
      },
    },
  });
